import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { PackagePlus, UploadCloud } from "lucide-react"; // Added UploadCloud
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePartsQuota } from "../../hooks/usePartsQuota";
import { getEffectivePlan } from "../../utils/subscriptionUtils";

const DashboardHeader = ({ variants }) => {
  const { currentSubscription } = useSelector((state) => state.auth);
  const { canAddParts } = usePartsQuota();

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  return (
    <motion.div
      className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4"
      variants={itemVariants} // Apply item variant for individual animation
    >
      <h1 className="self-center text-[29px] xs:text-3xl font-bold">
        Business Dashboard
      </h1>
      {canAddParts && (
        <div className="self-center flex flex-col xs:flex-row gap-4 md:gap-2 w-full xs:w-auto">
          <Link to="/dashboard/add-part" className="">
            <Button className="w-full">
              <PackagePlus className="mr-2 h-4 w-4" /> Add New Part
            </Button>
          </Link>
          {getEffectivePlan(currentSubscription) === "premium" && (
            <Link to="/dashboard/bulk-add-parts" className="">
              {" "}
              <Button variant="outline" className="w-full">
                <UploadCloud className="mr-2 h-4 w-4" /> Add Parts in Bulk
              </Button>
            </Link>
          )}
        </div>
      )}
    </motion.div>
  );
};

export default DashboardHeader;
